// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__sYlci","left":"InfoRow_left__2cLFU"};